import { Injectable } from '@angular/core';

@Injectable()

export class FileToBase64 {

  static transform = (file: any, callback: any) => {
    const fileReader = new FileReader();
    fileReader.addEventListener('load', (e) => {
      if (typeof callback === 'function') {
        callback(fileReader.result);
      }
    });
    fileReader.readAsDataURL(file);

  }
}
